import { Action, createReducer, on } from '@ngrx/store';
import { ApprovesActions } from './approves.actions';
import { approvesInitialState, ApprovesState } from './approves.state';
import { CacheableState } from '@utils/cacheable-state';

const _approvesReducer = createReducer(
  approvesInitialState(),

  /**
   * Reducers For Approves
   */

  on(ApprovesActions.getAllApproves, (state) => {
    return {
      ...state,
      allApproves: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.getAllApprovesSuccess, (state, { response }) => {
    return {
      ...state,
      allApproves: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.getAllApprovesFailure, (state, { failure }) => {
    return {
      ...state,
      allApproves: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Export Approves
   */
  on(ApprovesActions.exportApproves, (state) => {
    return {
      ...state,
      exportApproves: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.exportApprovesSuccess, (state, { response }) => {
    return {
      ...state,
      exportApproves: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.exportApprovesFailure, (state, { failure }) => {
    return {
      ...state,
      exportApproves: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Export Approves
   */
  on(ApprovesActions.getRequestById, (state) => {
    return {
      ...state,
      requestToApprove: {
        loading: true,
        data: null,
      },
    };
  }),
  on(ApprovesActions.getRequestByIdSuccess, (state, { response }) => {
    return {
      ...state,
      requestToApprove: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.getRequestByIdFailure, (state, { failure }) => {
    return {
      ...state,
      requestToApprove: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Approve A Request
   */
  on(ApprovesActions.approveARequest, (state) => {
    return {
      ...state,
      approveARequest: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.approveARequestSuccess, (state, { response }) => {
    return {
      ...state,
      approveARequest: {
        loading: false,
        data: true,
      },
    };
  }),
  on(ApprovesActions.approveARequestFailure, (state, { failure }) => {
    return {
      ...state,
      approveARequest: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Deny A Request
   */
  on(ApprovesActions.denyARequest, (state) => {
    return {
      ...state,
      denyARequest: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.denyARequestSuccess, (state, { response }) => {
    return {
      ...state,
      denyARequest: {
        loading: false,
        data: true,
      },
    };
  }),
  on(ApprovesActions.denyARequestFailure, (state, { failure }) => {
    return {
      ...state,
      denyARequest: {
        loading: false,
        failure: failure,
      },
    };
  }),
  on(
    ApprovesActions.approveARequestSuccess,
    ApprovesActions.denyARequestSuccess,
    (state, { response }) => {
      return {
        ...state,
        requestToApprove: new CacheableState({
          ...state.requestToApprove,
          data:
            state.requestToApprove.data?.id === response.data.id
              ? {
                  ...state.requestToApprove.data,
                  status: response.data.status,
                }
              : state.requestToApprove.data,
        }),
        requestsToApprove: new CacheableState({
          ...state.requestToApprove,
          data: state.requestsToApprove.data?.filter((request) => {
            return request.id !== response.data.id;
          }),
        }),
      };
    }
  ),

  /**
   * Reducers For Get All Approvers
   */
  on(ApprovesActions.myApproves, (state) => {
    return {
      ...state,
      myApproves: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.myApprovesSuccess, (state, { response }) => {
    return {
      ...state,
      myApproves: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.myApprovesFailure, (state, { failure }) => {
    return {
      ...state,
      myApproves: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get My Approvals Count
   */
  on(ApprovesActions.approvalsCount, (state) => {
    return {
      ...state,
      approvalsCount: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.approvalsCountSuccess, (state, { response }) => {
    return {
      ...state,
      approvalsCount: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.approvalsCountFailure, (state, { failure }) => {
    return {
      ...state,
      approvalsCount: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get My Approvals Count
   */
  on(ApprovesActions.pendingApprovals, (state) => {
    return {
      ...state,
      requestsToApprove: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.pendingApprovalsSuccess, (state, { response }) => {
    return {
      ...state,
      requestsToApprove: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.pendingApprovalsFailure, (state, { failure }) => {
    return {
      ...state,
      requestsToApprove: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get Approver By Company
   */
  on(ApprovesActions.getApproversByCompany, (state) => {
    return {
      ...state,
      approversByCompany: {
        loading: true,
      },
    };
  }),
  on(ApprovesActions.getApproversByCompanySuccess, (state, { response }) => {
    return {
      ...state,
      approversByCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ApprovesActions.getApproversByCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      approversByCompany: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function approvesReducer(
  state: ApprovesState | undefined,
  action: Action
) {
  return _approvesReducer(state, action);
}
